import { motion } from "framer-motion";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

const cn = (...inputs) => twMerge(clsx(inputs));

const paths = [
    "M-200 40 C 120 40 260 80 520 140 C 780 200 980 220 1400 220",
    "M-200 120 C 80 160 260 180 520 160 C 820 140 1040 120 1400 140",
    "M-200 200 C 120 200 280 240 520 280 C 820 320 1040 320 1400 320",
    "M-200 280 C 120 260 260 260 520 320 C 780 380 980 420 1400 440",
    "M-200 360 C 80 360 260 380 520 420 C 820 460 1040 460 1400 480"
];

const BackgroundBeams = ({ className }) => {
    return (
        <div className={cn("pointer-events-none absolute inset-0 h-full w-full", className)}>
            <svg
                className="absolute inset-0 h-full w-full"
                viewBox="0 0 1200 520"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                {paths.map((d, index) => (
                    <motion.path
                        key={`beam-${index}`}
                        d={d}
                        className="stroke-white/70"
                        strokeWidth="1.5"
                        strokeOpacity="0.5"
                        strokeLinecap="round"
                        strokeDasharray="6 10"
                        vectorEffect="non-scaling-stroke"
                        initial={{ strokeDashoffset: 0 }}
                        animate={{ strokeDashoffset: -220 }}
                        transition={{
                            duration: 10,
                            repeat: Infinity,
                            ease: "linear",
                            delay: index * 0.6
                        }}
                    />
                ))}
            </svg>
        </div>
    );
};

export default BackgroundBeams;
